<template>
  <div
    class="search"
    :style="{ height: regionList.length > 0 ? '50px' : '50px' }"
    :class="{ closeState: close }"
  >
    <el-form
      :inline="true"
      ref="formRef"
      :model="tableParams"
      class="form_inline"
    >
      <el-row class="seachSelect">
        <el-col :span="18">
          <el-cascader
            ref="cascaderRef"
            v-model="regionList"
            placeholder="请选择区域"
            :options="treeArea"
            :props="propsObj"
            clearable
            collapse-tags
            @change="organizationChange"
          />
        </el-col>
        <el-col :span="6" class="searchBtn">
          <el-button type="primary" size="default" @click="getRegion"
            >查询</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
  <div class="otherSearch" :class="{ closeState: close }" v-if="nextSearch">
    <el-form
      :inline="true"
      ref="formRef"
      :model="tableParams"
      class="form_inline"
    >
      <el-row class="seachSelect">
        <el-col :span="24"
          ><el-autocomplete
            v-model="tableParams.name"
            :fetch-suggestions="searchAsync"
            @select="handleSelect"
            placeholder="请选择设备"
            clearable
          >
            <template #suffix>
              <div @click="getPoint" style="cursor: pointer">
                <el-icon>
                  <Search></Search>
                </el-icon>
              </div>
            </template>
          </el-autocomplete>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
} from "vue";
import { Search } from "@element-plus/icons-vue";
import { queryTreeAreaVideo } from "@/api/videoControl/videoApi.js";
import { getMenutree, leftListquery } from "@/api/system/region.js";
import { unitList } from "@/api/threeSolid/fileManagement.js";
import { securitylist } from "@/api/threeSolid/threeSolid.js";
import {
  getUnitRegion,
  getHouseRegion,
  getPersonNumByRegion,
  getSecurityRegion,
} from "@/api/home/home.js";

import { ElMessage } from "element-plus";
export default defineComponent({
  name: "search",
  components: { Search },
  props: {
    close: {
      type: Boolean,
      default: false,
    },
    nextSearch: {
      type: Boolean,
      default: false,
    },
    equipemntType: {
      type: String,
      default: "",
    },
    isMultiple: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["emitLocation"],
  setup(props, context) {
    const data = reactive({
      loading: false,
      propsObj: {
        label: "name",
        value: "id",
        multiple: props.isMultiple,
        checkStrictly: true,
      },
      tableParams: {
        name: "",
        treeId: "",
      },
      treeArea: [],
      timeOut: null,
      regionList: [],
    });
    const refData = toRefs(data);
    const cascaderRef = ref(null);
    watchEffect(() => {
      if (props.equipemntType) {
        data.tableParams.name = "";
      }
    });
    const changeTreeId = () => {
      data.tableParams.name = "";
      context.emit("emitLocation", { regionId: "1" });
    };
    // 点击输入框数据
    const handleSelect = async (item) => {
      //有的返回点位数组。有点返回对象
      if (props.equipemntType == "区域信息") {
        context.emit("emitLocation", item);
      } else {
        const newItem =
          props.equipemntType == "监控设备" ? item : item.regionInfo;
        if (!newItem.longitude || !newItem.latitude) {
          ElMessage.warning("点位不完整信息,请更新");
          return;
        }
        const location = [Number(newItem.longitude), Number(newItem.latitude)];

        context.emit("emitLocation", {
          location: location,
          zoom: props.equipemntType == "监控设备" ? 18 : 14,
        });
      }
    };
    // 输入框检索
    const searchAsync = async (queyString, cb) => {
      const form = {
        areaId: data.tableParams.treeId,
        search: data.tableParams.name,
      };
      clearTimeout(data.timeOut);
      data.timeOut = setTimeout(async () => {
        if (props.equipemntType === "监控设备") {
          const res = await queryTreeAreaVideo(form);
          if (res.code == 0) {
            res.cameraBaseDtls.forEach((element) => {
              element.value = element.cameraName;
            });
            cb(res.cameraBaseDtls);
          }
        } else if (props.equipemntType === "区域信息") {
          const parms = {
            id: data.tableParams.treeId,
            name: data.tableParams.name,
            type: "3",
            isPage: false,
          };
          const res = await leftListquery(parms);
          if (res.code == 0) {
            res.page.list.forEach((element) => {
              element.value = element.name;
            });

            cb(res.page.list);
          }
        } else if (props.equipemntType === "实有单位") {
          const parms = {
            regionId: data.tableParams.treeId,
            unitName: data.tableParams.name,
            isPage: false,
          };
          const res = await unitList(parms);
          if (res.code == 0) {
            res.page.list.forEach((element) => {
              element.value = element.unitName;
            });

            cb(res.page.list);
          }
        } else if (props.equipemntType === "安防设施") {
          const parms = {
            regionId: data.tableParams.treeId,
            search: data.tableParams.name,
            isPage: false,
          };
          const res = await securitylist(parms);
          if (res.code == 0) {
            res.page.list.forEach((element) => {
              element.value = element.securityName;
            });

            cb(res.page.list);
          }
        } else if (props.equipemntType === "实有房屋") {
          const parms = {
            regionId: data.tableParams.treeId,
            name: data.tableParams.name,
            type: "4",
            isPage: false,
          };
          const res = await getHouseRegion(parms);
          if (res.code == 0) {
            res.data.forEach((element) => {
              element.value = element.name;
            });

            cb(res.data);
          }
        }
      }, 1500);
    };
    // 获取区域树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      if (result.data) {
        const filterCommunity = (list) => {
          return list.filter((item) => {
            if (item.children.length > 0) {
              filterCommunity(item.children);
            }
            return item.type != "-1" || Number(item.type) < 4;
          });
        };
        data.treeArea = filterCommunity([result.data]);
      }
    };
    queryOrganTreAsync();
    const getRegion = () => {
      console.log(data.regionList);
      if (data.regionList.length > 0) {
        let list = [];
        data.regionList.forEach((item) => {
          props.isMultiple ? list.push(...item.slice(-1)) : list.push(item);
        });
        props.isMultiple
          ? context.emit("emitRegionList", list)
          : context.emit("emitRegionList", list.slice(-1));
      } else {
        context.emit("emitRegionList", []);
      }
    };

    return {
      ...refData,
      cascaderRef,
      handleSelect,
      searchAsync,
      changeTreeId,
      getRegion,
    };
  },
});
</script>
<style lang="scss" scoped>
.search {
  width: 320px;
  height: 65px;
  position: absolute;
  animation: rightBox 0.5s;
  top: 40px;
  right: 435px;
  z-index: 2; //最小是2否则回被挡住
  border-radius: 4px;
  background: rgba(98, 98, 98, 0.5);
  @include flex-row-c-c;
  .form_inline {
    height: 100%;
    @include flex-col-se-c;
    .searchBtn {
      padding-left: 12px;
      @include flex-row-c-c;
    }
  }
  .seachSelect {
    padding: 0 10px;
    .el-icon-search {
      color: #fff;
    }
    :deep(.el-autocomplete) {
      width: 100%;
    }
  }
  .marginrow {
    margin: 10px 0;
  }
  .leftSelect {
    padding-right: 10px;
  }

  :deep(.el-input__inner) {
    &::placeholder {
      color: #fff;
    }

    &::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      color: #fff;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #fff;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      color: #fff;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      color: #fff;
    }
  }
  :deep(input) {
    background-color: rgba(62, 121, 191, 1) !important;
    border: 1px solid #3e79bf;
    color: #fff;
  }
  :deep(.el-input__icon) {
    // background-color: #fff;
    // border: 1px solid #3e79bf;
    color: #fff;
  }

  :deep(.el-cascader__search-input) {
    margin: 2px 0 2px 12px;
  }

  &.closeState {
    // transform-origin: 0 0;
    animation: leftBox 0.5s;
    right: 15px;
  }
}
.otherSearch {
  width: 320px;
  height: 50px;
  position: absolute;
  animation: rightBox 0.5s;
  top: 120px;
  right: 435px;
  z-index: 2; //最小是2否则回被挡住
  border-radius: 4px;
  background: rgba(98, 98, 98, 0.5);
  @include flex-row-c-c;
  .form_inline {
    height: 100%;
    width: 100%;
    @include flex-row-c-c;
  }
  .seachSelect {
    width: 100%;
    padding: 0 10px;
    .el-icon-search {
      color: #fff;
    }
    :deep(.el-autocomplete) {
      width: 100%;
    }
  }
  .marginrow {
    margin: 10px 0;
  }
  .leftSelect {
    padding-right: 10px;
  }

  :deep(.el-input__inner) {
    &::placeholder {
      color: #fff;
    }

    &::-webkit-input-placeholder {
      /* WebKit browsers 适配谷歌 */
      color: #fff;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 适配火狐 */
      color: #fff;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ 适配火狐 */
      color: #fff;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+  适配ie*/
      color: #fff;
    }
  }
  :deep(input) {
    background-color: rgba(62, 121, 191, 1) !important;
    border: 1px solid #3e79bf;
    color: #fff;
  }
  :deep(.el-input__icon) {
    // background-color: #fff;
    // border: 1px solid #3e79bf;
    color: #fff;
  }

  :deep(.el-cascader__search-input) {
    margin: 2px 0 2px 12px;
  }

  &.closeState {
    // transform-origin: 0 0;
    animation: leftBox 0.5s;
    right: 15px;
  }
}

@keyframes rightBox {
  0% {
    // transform: scaleX(0);
    // transform: translate(710px, 0px);
    right: 15px;
  }
  100% {
    // transform: scaleX(1);
    // transform: translate(0, 0);
    right: 435px;
  }
}
@keyframes leftBox {
  0% {
    // transform: scaleX(0);
    // transform: translate(-710px, 0px);
    right: 435px;
  }
  100% {
    // transform: scaleX(1);
    // transform: translate(0, 0);
    right: 15px;
  }
}
</style>
<style>
/* .searchPopperClass {
  background-color: rgba(62, 121, 191, 0.5);
  border: 1px solid rgba(62, 121, 191, 1);
} */
</style>
